import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import zhTranslation from "./locales/zh.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  zh: {
    translation: zhTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en", // Set English as the default fallback language
    supportedLngs: ["en", "zh"], // Support both English and Chinese
    interpolation: {
      escapeValue: false,
    },
    resources: resources,
    detection: {
      order: ["localStorage", "navigator", "htmlTag", "path", "subdomain"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
      htmlTag: document.documentElement,
    },
  });

export default i18n;
